import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { assetViewOptions, invoiceViewOptions } from '../../constants/viewOptions';

// Define the initial state for UI settings
interface UiSettingsState {
  assetView: string;
  invoiceView: string;
  isPrivateLabel: boolean;
  loginRedirectUrl?: string;
}

const initialState: UiSettingsState = {
  assetView: assetViewOptions[0].id, // Default to the first view (assetSpecs)
  invoiceView: invoiceViewOptions[0].id, // Default to the first view (e.g., 'invoiceSummary')
  isPrivateLabel: false, // Default to false
  loginRedirectUrl: undefined,
};

export const uiSettingsSlice = createSlice({
  name: 'uiSettings',
  initialState,
  reducers: {
    setAssetView: (state, action: PayloadAction<string>) => {
      state.assetView = action.payload;
    },
    setInvoiceView: (state, action: PayloadAction<string>) => {
      state.invoiceView = action.payload;
    },
    setIsPrivateLabel: (state, action: PayloadAction<boolean>) => {
      state.isPrivateLabel = action.payload;
    },
    setLoginRedirectUrl: (state, action: PayloadAction<string | undefined>) => {
      state.loginRedirectUrl = action.payload;
    },
  },
});

// Export actions
export const { setAssetView, setInvoiceView, setIsPrivateLabel, setLoginRedirectUrl } = uiSettingsSlice.actions;

// Export selectors
export const selectAssetView = (state: RootState) => state.uiSettings.assetView;
export const selectInvoiceView = (state: RootState) => state.uiSettings.invoiceView;
export const selectIsPrivateLabel = (state: RootState) => state.uiSettings.isPrivateLabel;
export const selectLoginRedirectUrl = (state: RootState) => state.uiSettings.loginRedirectUrl;

export default uiSettingsSlice.reducer;